import type { GrowthCategory } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'
import { CategoryButton } from './CategoryButton'

export const SubcategoryPageCategoryButton = (props: {
  category: GrowthCategory
  order: number
}) => {
  const { primaryCategory } = useStaticData<{
    primaryCategory: GrowthCategory | null
  }>()
  return <CategoryButton {...props} currentCategory={primaryCategory} />
}
